module.exports = __webpack_public_path__ + "img/product_1.1d4d37b.svg";